import GOTUtil from "../sysauthorityforIndustrialInternet/SysAuthoritySetup/Authority/GOTUtil";
import StringUtil from "./StringUtil";

export default class GOT
{
	static INDEP_FORM_ID = "60000000";

	static getForm(formId)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
		  var forms = _parentWindow.got.DataDictionary.Forms;
		  for(var i in forms)
		  {
		  	var form = forms[i];
		  	if(form.id == formId || form.name == formId)
		  		return form;
		  }
		}
		return null;
	}

	static setForm(form)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
		  var forms = _parentWindow.got.DataDictionary.Forms;
		  if(forms==null)
			//_parentWindow.setFirstForm(form);
		  	_parentWindow.got.DataDictionary["Forms"] = [form];
		  else
		  	forms.push(form);
		}
		return null;
	}


	static deleteForm(_id)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
		  var forms = _parentWindow.got.DataDictionary.Forms;
		  if(forms)
		  {
		  	for(let i = 0;i<forms.length;i++)
		  	{
		  		let form = forms[i];
		  		if(form.id == _id)
		  		{
		  			forms.splice(i,1);
		  		}
		  	}
		  }
		}
	}

	static getTable(tableId)
	{		
		var _parentWindow = window.parent.window;
		if(window.parent.window.formOSopenAllUniversal){
			var gots = _parentWindow.doMainGot
			for(var j in gots){
				  var tables = gots[j].got.DataDictionary.Tables;
				  for(var i in tables)
				  {
					  var table = tables[i];
					  if(table.id == tableId || table.name == tableId)
						  return table;
				  }
			}
		}else{
			if(_parentWindow)
			{
			  var tables = _parentWindow.got.DataDictionary.Tables;
			  for(var i in tables)
			  {
				  var table = tables[i];
				  if(table.id == tableId || table.name == tableId)
					  return table;
			  }
			}
			return null;
		}
	}
	static getdoMainTable(tableId,domain)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
		  var gots = _parentWindow.doMainGot
		  for(var j in gots){
				if(domain && domain == gots[j].doMain){
					var tables = gots[j].got.DataDictionary.Tables;
					for(var i in tables)
					{
						var table = tables[i];
						if(table.id == tableId || table.name == tableId)
							return table;
					}
				}
		  	}
		}
		return null;
	}

	static getTableFieldById(tableId,fieldId)
	{
		var table = GOT.getTable(tableId);
		if(!table)return null;
		var tableField = GOT.getTableField(table,fieldId);
		return tableField;
	}

	static getdoMainTableFieldById(tableId,fieldId,domain)
	{
		var table = GOT.getdoMainTable(tableId,domain);
		if(!table)return null;
		var tableField = GOT.getTableField(table,fieldId);
		return tableField;
	}

	static getTableField(table,fieldId)
	{
		for(var i in table.TableFields)
		{
			var tableField = table.TableFields[i];
			if(tableField.id == fieldId || tableField.name == fieldId)
				return tableField;
		}
		return null;
	}

	static getTableFieldComponentItems(tableField)
	{
		var extendPro = tableField.Properties.Extends;
		if(extendPro.hasOwnProperty("refentityid"))
		{
			var refentityid = extendPro.refentityid;
			var compDataType = GOT.getDataType(refentityid);
			return compDataType.DataTypeArrayItems;
		}
		return null;
	}

	static getTableIndex(table,innerid)
	{
		for(var i in table.TableIndexes)
		{
			var tableIndex = table.TableIndexes[i];
			if(tableIndex.id == innerid || tableIndex.name == innerid)
				return tableIndex;
		}
		return null;
	}

	static getAutoTableFieldGroup(table)
	{
		var tableFieldGroups = table.TableFieldGroups.FieldGroups;
		for(var i in tableFieldGroups)
		{
			var tableFieldGroup = tableFieldGroups[i];
			if(tableFieldGroup.name == "AutoLookup")
			{
				return tableFieldGroup;
			}
		}
		return null;
	}

	static getEnum(enumId,domain =null)
	{
		var _parentWindow = window.parent.window;
		if(!domain &&window.parent.initDomain && !window.parent.TableCheckDoMain){
			domain = window.parent.initDomain;
		}else if(!domain && window.parent.TableCheckDoMain){
			domain = window.parent.TableCheckDoMain;
		}
		if(window.parent.window.formOSopenAllUniversal){
			var gots = _parentWindow.doMainGot
			for(var j in gots){
				if(domain && gots[j].doMain == domain){
					var enums = gots[j].got.DataDictionary.Enums;
					for(var i in enums)
					{
						var enumItem = enums[i];
						if(enumItem.id == enumId)
							return enumItem;
					}
				}else{
					var enums = gots[j].got.DataDictionary.Enums;
					for(var i in enums)
					{
						var enumItem = enums[i];
						if(enumItem.id == enumId)
							return enumItem;
					}
				}
			}
		}else{
			if(_parentWindow)
			{
				var enums = _parentWindow.got.DataDictionary.Enums;
				for(var i in enums)
				{
					var enumItem = enums[i];
					if(enumItem.id == enumId)
						return enumItem;
				}
			}
		}
		return null;
	}

	
	static getDataType(dataTypeId)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
			var dataTypes = _parentWindow.got.DataDictionary.DataTypes;
			for(var i in dataTypes)
			{
				var dataType = dataTypes[i];
				if(dataType.id == dataTypeId || dataType.name == dataTypeId)
					return dataType;
			}
		}
		return null;
	}

	static getMenuItem(menuItemId)
	{
		var _parentWindow; //window.parent.window;
		if(window.got && window.got.MenuItems)
			_parentWindow = window;
		else
			_parentWindow = window.parent.window;
		if(_parentWindow)
		{
			var menuItems = _parentWindow.got.MenuItems;
			for(var i in menuItems)
			{
				var menuItem = menuItems[i];//TODO GOT属性容错
				if(menuItem.id == menuItemId || menuItem.name == menuItemId)
					return menuItem;
			}
		}
		return null;
	}

	static getMenu(menuId)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
			var menus = _parentWindow.got.DataDictionary.Menus;
			for(var i in menus)
			{
				var menu = menus[i];
				if(menu.id == menuId || menu.name == menuId)
					return menu;
			}
		}
		return null;
	}

	static getDataTypeArrayItem(dataType,id)
	{
		for(var i in dataType.DataTypeArrayItems)
		{
			var dataTypeArrayItem = dataType.DataTypeArrayItems[i];
			if(dataTypeArrayItem.id == id || dataTypeArrayItem.name == id)
				return dataTypeArrayItem;
		}
		return null;
	}

	static getFormDataSource(form,innerid)
	{
		for(var i in form.FormDataSources.DataSources)
		{
			var formDataSource = form.FormDataSources.DataSources[i];
			if(formDataSource.id == innerid || formDataSource.name == innerid)
				return formDataSource;
		}
		return null;
	}

	static getFormDataSourceField(formDataSource,innerid,exname=null,ingoreCase = false)
	{
		for(var i in formDataSource.FormDataSourceFields)
		{
			var formDataSourceField = formDataSource.FormDataSourceFields[i];
			if(formDataSourceField.id == innerid || formDataSourceField.name == innerid)
			{
				return formDataSourceField;
			}
			else if(exname)
			{
				if(ingoreCase == false)
				{
					if(formDataSourceField.id == exname || formDataSourceField.name == exname)
						return formDataSourceField;
				}
				else
				{
					let keyid = StringUtil.convertToAllLowerCase(formDataSourceField.id);
					let keyname = StringUtil.convertToAllLowerCase(formDataSourceField.name);
					exname = StringUtil.convertToAllLowerCase(exname);
					if(keyid == exname || keyname == exname)
					{
						return formDataSourceField;
					}
				}
				
			}
		}
		return null;
	}

	static getFormDataSourceFieldByName(form,dataSource,dataSourceField)
	{
		var dss = form.FormDataSources.DataSources;
		for(let i = 0;i<dss.length;i++)
		{
			var ds = dss[i];
			if(ds.name == dataSource)
				break;
		}

		if(ds)
		{
			return GOT.getFormDataSourceField(ds,dataSourceField)
		}
	}

	static getTableFieldGroup(table,id)
	{
		var fieldGroups = table.TableFieldGroups.FieldGroups;
		for(var i in fieldGroups)
		{
			var fieldGroup = fieldGroups[i];
			if(fieldGroup.id == id || fieldGroup.name == id)
				return fieldGroup;
		}
		return null;
	}

	static getTableIndex(table,id)
	{
		var indexes = table.TableIndexes.Indexes;
		for(var i in indexes)
		{
			var tableIndex = indexes[i];
			if(tableIndex.id == id || tableIndex.name == id)
				return tableIndex;
		}
		return null;
	}

	static getDataTypeRelationNormalItem(dataTypeRelation)
	{
		for(var i in dataTypeRelation.DataTypeRelationItems)
		{
			let dataTypeRelationItem = dataTypeRelation.DataTypeRelationItems[i];
			if(dataTypeRelationItem.type == "Normal")
				return dataTypeRelationItem;
		}
		let fieldPro = GOTUtil.getProperty(dataTypeRelation,"Field");
		if(!fieldPro)return null;
		let dataTypeRelationItem = {Properties:
			{
				Field:fieldPro
			}
		};
		return dataTypeRelationItem;
	}

	static getDataTypeRelationFixedItem(dataTypeRelation)
	{
		var fixedItems = [];
		for(var i in dataTypeRelation.DataTypeRelationItems)
		{
			let dataTypeRelationItem = dataTypeRelation.DataTypeRelationItems[i];
			if(dataTypeRelationItem.type == "Fixed")
				fixedItem.push(dataTypeRelationItem)
		}
		return fixedItems;
	}

	static getFormItem(form,id)
	{
		var formItems = form.FormDesign.FormItem;
		for(var i in formItems)
		{
			var item = formItems[i];
			if(item.id == id || item.name == id)
				return item;
			var result = GOT.getFormItemByFormItem(item,id);
			if(result != null)
				return result;
		}
		return null;
	}

	static getFormItemByFormItem(formItem,id)
	{
		for(var i in formItem.FormItem)
		{
			var item = formItem.FormItem[i];
			if(item.id == id || item.name == id)
				return item;
			var result = GOT.getFormItemByFormItem(item,id);
			if(result != null)
				return result;
		}
		return null;
	}

	static descendantsFormItemJsonType(jo,type,result)
	{
		if(!result)
			result = [];
		if(jo.type && jo.type.indexOf(type)!=-1)
		{
			result.push(jo)
		}
		else if(jo.FormItem)
		{
			for(var i = 0;i<jo.FormItem.length;i++)
			{
				var item = jo.FormItem[i];
				GOT.descendantsJson(item,type,result);
			}
		}
	}


	static descendantsJson(jo,qname,result)
	{
		if(!result)
			result = [];
		if(jo.qname == qname)
		{
			result.push(jo)
		}
		else if(jo.items)
		{
			for(var i = 0;i<jo.items.length;i++)
			{
				var item = jo.items[i];
				GOT.descendantsJson(item,qname,result);
			}
		}
	}

	static descendantsMainMenu(jo,qname,id,menuId)
	{
		if(jo.qname == qname && jo.id == id)
		{
			if(qname == "MenuItem")
			{
				jo.entityId = menuId;
			}
			return jo;
		}
		else if(jo.items)
		{
			for(var i = 0;i<jo.items.length;i++)
			{
				var item = jo.items[i];
				let _menuId = menuId;
				//TODO 由于MainMenu下面的Menu无明确标识 而主菜单开发时结构判断逻辑不严谨又不能加入qname
				//所以 暂时先这样判断其实Menu
				if(!item.hasOwnProperty("qname") && item.hasOwnProperty("version"))
				{
					_menuId = item.id;
				}
				let result = GOT.descendantsMainMenu(item,qname,id,_menuId);
				if(result)
					return result;
			}
		}
		return null;
	}

	static getMainMenuMenuItemById(mainMenu,id)
	{
		if(mainMenu.qname == "MenuItem" && mainMenu.id == id)
			return mainMenu;
		if(mainMenu.items)
		{
			for(var i = 0;i<mainMenu.items.length;i++)
			{
				var item = mainMenu.items[i];
				var result = GOT.getMainMenuMenuItemById(item,id);
				if(result)
					return result;
			}
		}
		return null;
	}

	static getComponentItems(tableField)
	{
		var extendPro = GOTUtil.getProperty(tableField,"Extends");
		if(extendPro.hasOwnProperty("refentityid"))
		{
			var compDataType = GOT.getDataType(extendPro.refentityid);
			return compDataType.DataTypeArrayItems;
		}
		return null;
	}
}


// WEBPACK FOOTER //
// ./src/utils/GOT.js